"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LapComputer_exports = {};
__export(LapComputer_exports, {
  default: () => LapComputer_default
});
module.exports = __toCommonJS(LapComputer_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.1836 3.58984C16.4961 3.58984 16.763 3.70052 16.9844 3.92188C17.2188 4.13021 17.3424 4.39062 17.3555 4.70312V4.76172V13.4922C17.3555 13.5833 17.3424 13.6745 17.3164 13.7656C17.3034 13.8568 17.2773 13.9414 17.2383 14.0195L17.2188 14.0586C17.2318 14.0586 17.2448 14.0651 17.2578 14.0781C17.2708 14.0911 17.2773 14.1042 17.2773 14.1172L17.3164 14.1562L18.7812 16.8125C18.8464 16.9167 18.8464 17.0273 18.7812 17.1445C18.7292 17.2487 18.6445 17.3138 18.5273 17.3398H18.4883H2.51172C2.39453 17.3398 2.29688 17.2878 2.21875 17.1836C2.15365 17.0794 2.14062 16.9688 2.17969 16.8516L2.19922 16.8125L3.60547 14.1562C3.61849 14.1432 3.63151 14.1302 3.64453 14.1172C3.65755 14.0911 3.67708 14.0651 3.70312 14.0391C3.66406 13.974 3.63151 13.9023 3.60547 13.8242C3.57943 13.7461 3.56641 13.668 3.56641 13.5898V13.4922V4.76172C3.56641 4.44922 3.67057 4.18229 3.87891 3.96094C4.10026 3.72656 4.36719 3.60286 4.67969 3.58984H4.73828H16.1836ZM16.1836 14.6836H4.13281L3.09766 16.6172H17.8828L16.8086 14.6836H16.2031H16.1836ZM11.9648 15.3281V16.0312H8.95703V15.3281H11.9648ZM16.1836 4.29297H4.73828C4.62109 4.29297 4.51693 4.33203 4.42578 4.41016C4.33464 4.48828 4.28255 4.59245 4.26953 4.72266V4.76172V13.4922C4.26953 13.6224 4.30859 13.7331 4.38672 13.8242C4.46484 13.9154 4.5625 13.9674 4.67969 13.9805H4.73828H16.1836C16.3008 13.9805 16.4049 13.9414 16.4961 13.8633C16.5872 13.7721 16.6393 13.668 16.6523 13.5508V13.4922V4.76172C16.6523 4.64453 16.6133 4.54036 16.5352 4.44922C16.457 4.35807 16.3529 4.30599 16.2227 4.29297H16.1836ZM14.4258 11.1484V11.8711H6.51562V11.1484H14.4258ZM14.4258 8.88281V9.58594H6.51562V8.88281H14.4258ZM10.832 6.57812V7.28125H6.51562V6.57812H10.832Z",
      fill: "currentColor"
    }
  )
);
const SvgLapComputer = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LapComputer_default = SvgLapComputer;
